export const CardInformationList: React.FC<{
  title: string;
  value: undefined | null | string | string[];
}> = ({ title, value }) => {
  return (
    <div className="flex justify-between items-center">
      <span className="basis-1/3">{title}</span>
      <div className="basis-2/3 flex gap-2">
        <span>:</span>
        <span className="text-left font-semibold">{value}</span>
      </div>
    </div>
  );
};